import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['Guía de situaciones reales', 'Plantillas de conversación', 'Sistema de seguimiento', 'Aplicación paso a paso', 'Sostener el cambio', 'Resultados reales'];
export function AulaListaSection() {
  return <section className="py-5 px-5 bg-[#000000]" data-id="element-26">
      <div className="max-w-xl mx-auto" data-id="element-27">
        <div className="text-center mb-8" data-id="element-28">
          <span className="text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide mb-4 inline-block border border-brand-yellow/30 text-[#FBBE24] bg-[#FBBE245D]" data-id="element-29">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3" data-id="element-30">
            🧠 ¿Qué agrega el Sistema de Cambio Familiar?
          </h2>
          <p className="text-sm text-gray-400 font-medium max-w-md mx-auto" data-id="element-31">
            Ya entendés lo que te pasa… 👉 esto te da{' '}
            <span className="text-brand-yellow font-bold" data-id="element-32">
              la forma de cambiarlo
            </span>{' '}
            en la vida real.
          </p>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 mb-8" data-id="element-33">
          <h3 className="text-base font-bold text-center mb-5 text-[#FBBE24] bg-[#FBBE2400]" data-id="element-34">
            💥 ESTO INCLUYE EL SISTEMA
          </h3>
          <div className="space-y-3" data-id="element-35">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-3 rounded-lg bg-[#7E9CFF54]" data-id="element-36">
                <CheckCircle className="text-brand-yellow flex-shrink-0" size={20} data-id="element-37" />
                <span className="text-sm font-semibold text-white" data-id="element-38">{item}</span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-slate-500 text-xs font-medium" data-id="element-39">
          La opción más recomendada para resultados más completos
        </p>
      </div>
    </section>;
}